
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CarHealthTabReminders from '@components/car-health/CarHealthTabReminders.vue';
import CarHealthTabWarnings from '@components/car-health/CarHealthTabWarnings.vue';
import { HealthIssueItem, MaintenanceItem } from '@clients/bff';

export type Tab = 'warnings' | 'reminders';

@Component({
  name: 'CarHealthTabs',
  components: {
    CarHealthTabReminders,
    CarHealthTabWarnings
  }
})
export default class CarHealthTabs extends Vue {
  @Prop({ default: false })
  private loading: boolean;

  @Prop({ required: true })
  private warnings: Array<HealthIssueItem>;

  @Prop({ required: true })
  private recommendations: Array<HealthIssueItem>;

  @Prop({ required: true })
  private reminders: Array<MaintenanceItem>;

  @Prop({ required: true })
  private activeTab: Tab;

  private clickTab(tab: Tab) {
    this.$emit('tabChanged', tab)
  }
}
